import { reactive, computed } from '@vue/composition-api'

export const SelectBox = (props, context) => {
  const data = reactive({
    lists: computed(() => props.lists),
    selected: computed(() => props.selected),
    selectedName: computed(() => {
      const select = data.lists.find((item) => item.value === data.selected) ?? data.lists[0]
      return select.name
    }),
    select: event => {
      const selectedValue = Number(event.target.value)
      group1.visibleSelect = false
      // data.selected = selectedValue
      context.emit('change', selectedValue)
    }
  })

  const group1 = reactive({
    visibleSelect: false
  })

  return {
    group1,
    data
  }
}
